import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  formLabel: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  switchLabel: {
    fontSize: 14,
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
